var components
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.style(200)
  var l0 = _vm.__map(_vm.orderDetail.skuList, function (item, index) {
    var $orig = _vm.__get_orig(item)
    var f0 =
      item.price < item.originalPrice
        ? _vm._f("priceFormat")(item.originalPrice)
        : null
    var f1 = _vm._f("priceFormat")(item.price)
    return {
      $orig: $orig,
      f0: f0,
      f1: f1,
    }
  })
  var f2 = _vm._f("statusFilter")(_vm.orderDetail.status)
  var f3 = _vm._f("priceFormat")(_vm.orderDetail.skuOriginalTotalPrice)
  var f4 =
    _vm.orderDetail.skuOriginalTotalPrice > _vm.orderDetail.skuTotalPrice
      ? _vm._f("priceFormat")(
          _vm.orderDetail.skuOriginalTotalPrice - _vm.orderDetail.skuTotalPrice
        )
      : null
  var f5 = _vm.orderDetail.couponPrice
    ? _vm._f("priceFormat")(_vm.orderDetail.couponPrice)
    : null
  var f6 = _vm._f("dateFormat")(_vm.orderDetail.gmtCreate)
  var f7 = _vm.orderDetail.payChannel
    ? _vm._f("payChannelFilter")(_vm.orderDetail.payChannel)
    : null
  var f8 = _vm.orderDetail.gmtPay
    ? _vm._f("dateFormat")(_vm.orderDetail.gmtPay)
    : null
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        l0: l0,
        f2: f2,
        f3: f3,
        f4: f4,
        f5: f5,
        f6: f6,
        f7: f7,
        f8: f8,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }